<template>
  <v-app id="ListPlaylist">
    <v-main>
      <v-card
        max-width="500"
        class="mx-auto"
      >
        <v-list disabled two-line>
         <v-list-item-group>
           <template v-for="(item, index) in list">
             <v-list-item :key="item.uuid">
               <template>
                <v-list-item-avatar>
                  <v-img
                    :src="get(item, 'track.album.images') || null"
                    alt=""
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-icon color="green">mdi-account-circle-outline</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                  </v-list-item-avatar>
                 <v-list-item-content>
                   <v-list-item-title v-text="item.track.name"></v-list-item-title>
                   <v-list-item-subtitle v-text="item.track.artists[0].name || null"></v-list-item-subtitle>
                 </v-list-item-content>
                 <v-list-item-action>
                   <v-list-item-action-text v-text="item.track.album.name.slice(0, 15)"></v-list-item-action-text>
                 </v-list-item-action>
               </template>
             </v-list-item>
             <v-divider
               v-if="index + 1 < newPlaylist.length"
               :key="index"
             ></v-divider>
           </template>
         </v-list-item-group>
        </v-list>
      </v-card>
      <v-row align="center">
        <v-col class="text-center" cols="12" sm="4">
            <!-- <v-btn large outlined color="red" @click="reset()">Reset</v-btn> -->
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
            <v-btn large outlined color="green" @click="shuffle()">Re-shuffle</v-btn>
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
          <div class="my-2">
            <v-btn large color="green" @click="create()">Store</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import unique from 'just-unique'
import safeGet from 'just-safe-get'
import axios from 'axios'

export default {
  props: {
    source: String
  },
  data: () => ({
    list: []
  }),
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      authToken: 'getUserToken',
      newPlaylist: 'getNewPlaylist',
      songs: 'getSongs',
      friendsSelection: 'getFriendsSelection'
    })
  },
  watch: {
    songs: function (newSongs) {
      this.list = unique(newSongs)
    },
    newPlaylist: function (newPlaylist) {
      this.list = unique(newPlaylist)
    }
  },
  methods: {
    get (arg1, arg2) {
      const value = safeGet(arg1, arg2)
      /* eslint valid-typeof: "error" */
      if (typeof value[0] === 'undefined') {
        return null
      } else {
        return value[0].url
      }
    },
    shuffle () {
      this.$store.commit('reShufflePlaylist')
    },
    async create () {
      const addSongs = async (playlistId, songs) => {
        const url = `https://api.spotify.com/v1/playlists/${playlistId}/tracks`
        const uris = []
        songs.forEach(song => {
          uris.push(song.track.uri)
        })
        const body = {
          uris: uris
        }
        await axios.post(url, body, { headers: { Authorization: this.authToken } }).then(res => {
          this.$router.push('/success')
        })
      }
      const createPlaylist = async (userId, name) => {
        const url = `https://api.spotify.com/v1/users/${userId}/playlists`
        const desc = 'A playlist for you, ' + this.friendsSelection.map(function (friend) { return friend.display_name }).join(',')
        const body = {
          name: name || 'Spuffle Playlist',
          description: desc || 'Playlists for you and me',
          public: false
        }
        await axios.post(url, body, { headers: { Authorization: this.authToken } }).then(res => {
          this.$store.commit('setLatestCreatedPlaylist', res.data)
          addSongs(res.data.id, this.list)
        })
      }
      await createPlaylist(this.user.id, null)
    },
    reset () {
      this.$store.commit('resetPlaylist')
    }

  },
  mounted () {
    this.$vuetify.theme.dark = true
  }
}
</script>
